module.exports = __webpack_public_path__ + "static/19-9875d2902000e47fa2e11611b4e9eaef.png";